import React from 'react';
import PermissionsLayout from './permissions-layout';

export default class Permissions extends React.Component<{}, {}> {
    render(){
        return(
            <PermissionsLayout/>
        )
    }
}